import React from 'react'
import Navbar from '../inc/Navbar'
import Lysorichgold from "../images/Lysorich Gold page.jpg";
import Lysorichgoldbottle from "../images/Lysorich Gold Capsules NEW..png"
function LysorichGold() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <img src={Lysorichgold} className="d-block w-100" alt="Lysorichgold" />
      <div className='LysorichSyrup'>
        <div className="album py-1">
          <div className="container">
            <center>
              <h2 className='mt-3'>Lysorich Gold</h2>
              <p>Omega 3 fatty acid+Green tea extract+Ginseng+Ginkgo Biloba Extract+ Grape Seed Extract+Multivitamin+Multimineral+Antioxidants with trace elements SFOT GEL CAPSULES</p>
            </center>
          </div>
        </div>
      </div>
      <b />

      <div className="album py-1">
        <div className="container">
          <center>
            <h1><b>Lysorich Gold</b> Uses </h1>
          </center>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img src={Lysorichgoldbottle} className="img-fluid " alt="Lysorichgoldbottle" />

            </div>

            <div className="col-md-8">
              <br/>
              <br/>
              <h5 style={{color:"#0499a0"}} className='mb-0'><b>Omega-3 Fatty Acids </b></h5>
              <p><small>Improves cardiovascular health</small></p>
               <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Antioxidants</b></h5>
              <p><small>Fight against harmful free radicals</small></p>
               <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Vitamins & Minerals</b></h5>
              <p><small>Fills deficiency gap</small></p>
                      <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Grape Seed Extract</b></h5>
              <p><small> Help Boost brain Function</small></p>
                             <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Ginkgo Biloba</b></h5>
              <p><small>Has antioxidants that cancer out free radicals</small></p>
                             
            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <div className='bg'>
            <br/>
          <center>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Convalescence</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Low energy & fatigue</p>

<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Vitamin & Mineral Deficiency</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Low Hb</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Recovery Phase</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> CVD</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Diabetes</p>
</center>
<br/>
</div>
        </div>
        </div>
        <br />
      </div>
      )
}

      export default LysorichGold